(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-size-chart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pdpSizeChartBound) return;
    window.__pdpSizeChartBound = true;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-size-chart-open]');
      if (opener) {
        var id = opener.getAttribute('data-size-chart-open');
        var dialog = document.getElementById(id);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else if (dialog) {
          dialog.setAttribute('open', '');
        }
        return;
      }
      var closer = e.target.closest('[data-size-chart-close]');
      if (closer) {
        var dlg = closer.closest('dialog');
        if (dlg && typeof dlg.close === 'function') {
          dlg.close();
        } else if (dlg) {
          dlg.removeAttribute('open');
        }
      }
    });

    document.addEventListener('click', function (e) {
      var dlg = e.target;
      if (dlg && dlg.tagName === 'DIALOG' && dlg.classList.contains('pdp-size-chart__dialog')) {
        var rect = dlg.getBoundingClientRect();
        var inside = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
        if (!inside && typeof dlg.close === 'function') dlg.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
